var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1486 4.3986C7.09317 2.45406 9.7817 1.25 12.75 1.25C15.7183 1.25 18.4068 2.45406 20.3514 4.3986L19.8211 4.92893L20.3514 4.3986C22.2959 6.34317 23.5 9.0317 23.5 12C23.5 14.9683 22.2959 17.6568 20.3514 19.6014C18.4068 21.5459 15.7183 22.75 12.75 22.75C9.7817 22.75 7.09317 21.5459 5.1486 19.6014L5.67893 19.0711L5.1486 19.6014C3.20406 17.6568 2 14.9683 2 12C2 9.0317 3.20406 6.34317 5.1486 4.3986L5.1486 4.3986ZM12.75 2.75C10.1955 2.75 7.88403 3.78452 6.20926 5.45926C4.53451 7.13404 3.5 9.4455 3.5 12C3.5 14.5545 4.53452 16.866 6.20926 18.5407C7.88403 20.2155 10.1955 21.25 12.75 21.25C15.3045 21.25 17.616 20.2155 19.2907 18.5407C20.9655 16.866 22 14.5545 22 12C22 9.4455 20.9655 7.13403 19.2907 5.45926C17.616 3.78452 15.3045 2.75 12.75 2.75Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.3125C9 7.24144 10.6789 5.5625 12.75 5.5625C14.8211 5.5625 16.5 7.24144 16.5 9.3125C16.5 11.1267 15.2117 12.64 13.5 12.9875L13.5 14.3125C13.5 14.7267 13.1642 15.0625 12.75 15.0625C12.3358 15.0625 12 14.7267 12 14.3125L12 12.3125C12 11.8983 12.3358 11.5625 12.75 11.5625C13.9926 11.5625 15 10.5551 15 9.3125C15 8.06986 13.9926 7.0625 12.75 7.0625C11.5074 7.0625 10.5 8.06986 10.5 9.3125C10.5 9.72671 10.1642 10.0625 9.75 10.0625C9.33579 10.0625 9 9.72671 9 9.3125Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 18.8125C13.4404 18.8125 14 18.2529 14 17.5625C14 16.8722 13.4404 16.3125 12.75 16.3125C12.0597 16.3125 11.5 16.8722 11.5 17.5625C11.5 18.2529 12.0597 18.8125 12.75 18.8125Z",
    fill: "#1C1B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.6f77c9a9fb0b09e5d892b8c88f0262a1.svg";
export { ForwardRef as ReactComponent };